import {
    Stack, Title, Text, Box, Group, Badge,
    Divider, List, Button, Container
} from '@mantine/core';
import {
    IconCircleCheck, IconReceipt,
    IconTruck
} from '@tabler/icons-react';
import { ShipmentDetails } from '../../types/shipping';
import { useNavigate } from 'react-router-dom';

interface SuccessModalProps {
    shipmentDetails: ShipmentDetails;
}

const SuccessModal = ({
    shipmentDetails
}: SuccessModalProps) => {
    const navigate = useNavigate();
    return (
        <Container size="sm">
            <Stack align="center" mb="xl">
                <IconCircleCheck size={80} color="green" stroke={1.5} />
                <Title order={2} ta="center">Shipment Successfully Created!</Title>
                <Text c="dimmed" ta="center">
                    Your shipment is created and processing. <b>Please pay to continue.</b> After payment, we’ll prepare your package for shipping. You can track it soon in your Shipments tab.
                </Text>

                <Box mb="md">
                    <Group >
                        <Text fw={700} size="lg">Shipment Details</Text>
                        <Badge size="lg" color="green">
                            Processing
                        </Badge>
                    </Group>
                    <Divider my="sm" />

                    <List spacing="xs" size="sm" icon={
                        <IconCircleCheck size={16} color="green" stroke={1.5} />
                    }>
                        <List.Item>
                            <Group >
                                <Text>Shipment ID:</Text>
                                <Text fw={500}>{shipmentDetails?.shipmentId}</Text>
                            </Group>
                        </List.Item>
                        <List.Item>
                            <Group >
                                <Text>Tracking Number:</Text>
                                <Text fw={500}>{shipmentDetails?.trackingNumber}</Text>
                            </Group>
                        </List.Item>
                        <List.Item>
                            <Group >
                                <Text>Created On:</Text>
                                <Text>{new Date(shipmentDetails?.createdAt).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })}</Text>
                            </Group>
                        </List.Item>
                        <List.Item>
                            <Group >
                                <Text>Estimated Delivery:</Text>
                                <Text>{shipmentDetails?.estimatedDelivery}</Text>
                            </Group>
                        </List.Item>
                    </List>
                </Box>

                <Group justify="center" mt="xl">
                    <Button
                        color="yellow"
                        size="md"
                        leftSection={<IconReceipt size={18} />}
                        onClick={() => window.location.href = shipmentDetails.url}
                    >
                        Pay Now
                    </Button>
                    <Button
                        variant="outline"
                        leftSection={<IconTruck size={18} />}
                        onClick={() => navigate('/shipments')}
                    >
                        View Shipments
                    </Button>

                    <Text size="sm" c="dimmed" ta="center" mt="sm">
                        You will be redirected to our payment gateway shortly.
                        While our app displays prices in USD, the payment gateway will show amounts in LKR.
                    </Text>
                    {/* <Button
                        leftSection={<IconReceipt size={18} />}
                        variant="outline"
                    >
                        Download Invoice
                    </Button>
                    <Button
                        component={Link}
                        to="/shipments"
                        leftSection={<IconTruck size={18} />}
                    >
                        View Shipment Details
                    </Button> */}
                </Group>
            </Stack>
        </Container>
    );
};

export default SuccessModal;
